import { render, staticRenderFns } from "./LojaLoading.vue?vue&type=template&id=5a2de118"
import script from "./LojaLoading.vue?vue&type=script&lang=js"
export * from "./LojaLoading.vue?vue&type=script&lang=js"
import style0 from "./LojaLoading.vue?vue&type=style&index=0&id=5a2de118&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports